import type { SVGProps } from 'react';

export function SearchIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15.0004 14.9995"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M6.3623 0C9.87437 0.000218518 12.7235 2.85022 12.7236 6.3623C12.7235 7.80871 12.2397 9.14327 11.4277 10.2109L14.7461 13.5293L14.8057 13.5938C15.0839 13.9312 15.0639 14.4351 14.7461 14.749L14.7441 14.748C14.4066 15.0835 13.8642 15.0836 13.5273 14.7471L10.208 11.4297C9.14041 12.2417 7.80867 12.7235 6.3623 12.7236C2.84718 12.7235 0.000218288 9.87429 0 6.3623C0.000136416 2.85025 2.84713 0.000136448 6.3623 0ZM6.3623 1.72949C3.80688 1.72963 1.72963 3.80963 1.72949 6.3623C1.72971 8.9147 3.80673 10.9921 6.3623 10.9922C8.91496 10.992 10.9949 8.91455 10.9951 6.3623C10.995 3.80979 8.9148 1.72971 6.3623 1.72949Z" fill="currentColor" />
    </svg>
  );
}
